import React from 'react';
import PropTypes from 'prop-types';
const Developers = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M25.6667 33.0634L20.6033 28.0001L25.6667 22.9367L22.3767 19.6234L14 28.0001L22.3767 36.3767L25.6667 33.0634Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M33.6234 36.3767L42 28.0001L33.6234 19.6234L30.3334 22.9367L35.3967 28.0001L30.3334 33.0634L33.6234 36.3767Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M44.3333 7.00004H34.58C33.6 4.29337 31.0333 2.33337 28 2.33337C24.9667 2.33337 22.4 4.29337 21.42 7.00004H11.6667C11.34 7.00004 11.0367 7.02337 10.7333 7.09337C9.82333 7.28004 9.00667 7.74671 8.37667 8.37671C7.95667 8.79671 7.60667 9.31004 7.37333 9.87004C7.14 10.4067 7 11.0134 7 11.6667V35V37.3334V44.3334C7 44.9634 7.14 45.5934 7.37333 46.1534C7.60667 46.7134 7.95667 47.2034 8.37667 47.6467C9.00667 48.2767 9.82333 48.7434 10.7333 48.93C11.0367 48.9767 11.34 49 11.6667 49H44.3333C46.9 49 49 46.9 49 44.3334V37.3334V35V11.6667C49 9.10004 46.9 7.00004 44.3333 7.00004ZM28 6.41671C28.9567 6.41671 29.75 7.21004 29.75 8.16671C29.75 9.12337 28.9567 9.91671 28 9.91671C27.0433 9.91671 26.25 9.12337 26.25 8.16671C26.25 7.21004 27.0433 6.41671 28 6.41671ZM44.3333 35V37.3334V44.3334H11.6667V37.3334V35V11.6667H44.3333V35Z"
      fill={fill || '#6B6C7B'}
    />
  </svg>
);
Developers.propTypes = {
  fill: PropTypes.string,
};
export default Developers;
